export class TrackingService {
    constructor() {
        this.scriptLoaded = false;
    }

    get digitalData() {
        return window.digitalData;
    }

    set digitalData(obj) {
        window.digitalData = obj;
    }

    static getInstance() {
        if (!this.instance) {
            this.instance = new TrackingService();
        }
        return this.instance;
    }

    trackPage() {
        if (sessionStorage.getItem("link")) {
            console.log("link tracking:", sessionStorage.getItem("link"));
            sessionStorage.removeItem("link");
        }

        let attributeType = window.location.pathname === '/' ? "Homepage" : window.location.pathname === "/site-map" ? "SiteMap" : window.location.pathname === '/search-results' ? 'Search Results' : window.location.pathname === "/page-not-found" || window.location.pathname == "/system-error" ? "Error Page" : window.location.pathname === "/about-us" ? "Indication Landing Page" : window.location.pathname === "/clinical-overview" ? "Clinical Efficacy" : window.location.pathname === "/symptoms-diagnosis" || window.location.pathname =="/peer-exchange/diagnosis-epi" ? "Diagnosis" : window.location.pathname === "/peer-exchange/epi-pancreatic-diseases" ? "Disease State Awareness" : "Resources";

        const otherURLs = ['pert-faqs', 'find-msl', 'site-map', 'page-not-found', 'system-error'];
        const regexUrls = RegExp(otherURLs.join('|'));

        const journeyContent = window.location.pathname === '/' || window.location.pathname == '/about-us' ? "brand benefit" : window.location.pathname === '/search-results' ? 'Search Results' : window.location.pathname === '/peer-exchange/epi-pancreatic-surgery' ? 'postTreatment' : window.location.pathname === '/peer-exchange/epi-unresectable-pancreatic-cancer-case-study' ? 'Living With' : regexUrls.test(window.location.pathname) ? 'Other' : 'Educate';

        let pageName;

        const subdomain = window.location.host.split('.').length > 1 ? window.location.host.split('.')[0] : '';

        if (document.getElementsByClassName("subpage")[0]) {
            pageName = document.getElementsByClassName("subpage")[0].getAttribute("data-subcategory");
     
        } else if (document.getElementsByClassName("page-container")[0]) {
            pageName = document.getElementsByClassName("page-container")[0].getAttribute("data-pageName");
        }
        else {
            pageName = window.location.pathname == '/' ? "Homepage" : window.location.pathname == '/education' ? "Education" : window.location.pathname.includes("/peer-exchange/") ? window.location.pathname.replace("/peer-exchange/", "").replaceAll("-", " "): window.location.pathname.replaceAll("/", "").replaceAll("-", " ");
        }


        const primaryCategory = window.location.pathname === '/' ? "Home" : window.location.pathname.includes("about-us") ? "about us" : window.location.pathname.includes("clinical-overview") ? "clinical overview" : window.location.pathname.includes("page-not-found") || window.location.pathname.includes("error") ? 'Error' : window.location.pathname == '/search-results' ? "Search Results" : window.location.pathname == '/symptoms-diagnosis' ? "Diagnosis" : window.location.pathname == '/management' ? "management and treament" : window.location.pathname == '/epi-pediatric-population' ? "epi in pediatric population" : window.location.pathname == '/events-calendar' ? "events calendar" : window.location.pathname == '/patient-education-materials' || window.location.pathname == '/peer-exchange/epi-unresectable-pancreatic-cancer-case-study' ? "Education" : window.location.pathname == '/hcp-resources' || window.location.pathname == '/resources' ? "Resources" : window.location.pathname == '/pert-faqs' ? "faqs" : window.location.pathname == '/find-msl' ? "find my msl" : window.location.pathname == '/site-map' ? "/site-map" : "peer exchange";

        const subcategoryName = !window.location.pathname.includes("peer-exchange") ? "" : window.location.pathname == '/peer-exchange/clinical-consequences-epi' || window.location.pathname == '/peer-exchange/diagnosis-epi' || window.location.pathname == '/peer-exchange/explore-epi' || window.location.pathname == '/peer-exchange' ? "" : window.location.pathname == '/peer-exchange/differentiating-epi-ibsd' ? "differentiating epi ibsd" : window.location.pathname == '/peer-exchange/epi-celiac' ? "celiac disease" : "pancreatic disease";


        this.pageData = {
            page: {
                pageInfo: {
                    domain: 'essentialsofepi.com',
                    subDomain: subdomain,
                    url: window.location.href,
                    path: window.location.pathname,
                    pageName: pageName,
                    title: document.title,
                    prefix: 'essentialsofepi'
                },
                category: {
                    primaryCategory: primaryCategory,
                    subCategory1: subcategoryName ? subcategoryName : '',
                    subCategory2: ''
                },
                attributes: {
                    language: 'en-US',
                    country: 'US',
                    template: '',
                    promoMatsNumber: 'ABBV-US-01124-MC',
                    globalISI: '',
                    type: attributeType,
                },
                journey: { content: journeyContent, patient: '', messageBucket: '' },
                product: {
                    name: '',
                    franchise: 'Gastroenterology (Gastro)',
                    indication: 'Exocrine Pancreatic Insufficiency (EPI)',
                    division: 'Gastrointestinal Care',
                    brand: 'DSA'
                }, site: {
                    type: 'Unbranded', experience: 'Medical Affairs', audience: 'health care professional (HCP)'
                },
                modal: { type: '', name: '', position: '', enabled: '', displayed: '' },
                search: { autoPosition: '', term: '', count: '', type: '', filterType: '', filterValue: '', filterCategory: '', sortByInit: '', origin: '', originURL: '' }
            },
            user: [{
                profile: [{
                    id: { crmID: '', transID: '', abbvieCustomerID: '', hcpAccountID: '', npiID: '', dmpID: '', adobeID: '' }, attributes: { status: '', type: '' },
                }]
            }]
        };

        this.digitalData = this.pageData;

        console.log('page level tracking', this.digitalData);
        _satellite.track('trackState');
    }


    trackInteraction(link, time) {
        let linkInfo, linkType, linkName, componentType, componentName, componentPosition, interactionType, contentType, linkUrl, mvaTier, mvaCategory, videoId, videoLength, videoTitle,videoAction, componentTitle, toolName, toolLocation, displayTitle, formName,formSubCategory,formCategory, stepName, fieldName, fieldValue, mvaName, mvaType, toolFieldName, toolFieldValue, toolType, videoDuration;

        function getVideoTracking(link, time) {
            let video;

            if (time) {
                video = document.getElementById(sessionStorage.videoid);
                videoTitle = video.getAttribute("data-tracking");
            } else {
                video = link.target.closest('video-js');
                videoTitle = video.getAttribute("data-tracking");
                sessionStorage.videoid = video.getAttribute("id");
            }
           
            
            const isPaused = video.classList.contains('vjs-paused');
            const hasStarted = video.classList.contains('vjs-has-started');
            const hasEnded = video.classList.contains('vjs-ended');

            interactionType = "Video";
            contentType = "Video";
            componentName = "video player";
            componentType = "content";
            componentPosition = "Content";
            componentTitle = video.getAttribute("data-componentTitle");
            linkName = videoTitle + (time ? time !== 100 ? ' - ' + time + '%' : ' - End' : ' - ' + (hasStarted && !isPaused ? 'Pause' : isPaused && !hasStarted ? 'Start' : 'Resume'));
            videoAction = time ? time !== 100 ? time + '%' : 'End' : (hasStarted && !isPaused ? 'Pause' : isPaused && !hasStarted ? 'Start' : hasEnded && isPaused ? 'Replay' : 'Resume');
            linkName = hasEnded && isPaused ? videoTitle + ' - Replay' : linkName;
            linkUrl = window.location.href;
            linkType = "Video-interaction";
            const linkNameHasEnd = linkName.split('-')[1]?.includes('End');
            mvaName = linkNameHasEnd ? '' : videoTitle;
            mvaTier = linkNameHasEnd ? '' : "primary";
            mvaType = linkNameHasEnd ? '' : "video";
            
            mvaCategory = linkNameHasEnd ? '' : window.location.pathname == '/'?"Patient Story": "KOL";
            videoId = video.getAttribute("data-video-id");
            videoLength = document.getElementsByClassName("vjs-duration-display")[0].innerHTML;
            videoDuration = document.getElementsByClassName("vjs-current-time-display")[0].innerHTML;
        };

        function getLinkTracking(link) {
 
            linkInfo = link.target.nodeName == 'A' ? link.target : link.target.closest("a");
            linkType = (linkInfo.href.includes(window.location.host) && !linkInfo.href.includes(".pdf") || linkInfo.href == "javascript:void(0);" || window.location.pathname == '/events-calendar' || window.location.pathname == '/resources' ) ? "Internal" : linkInfo.href.includes(".pdf") ? "Download" : "External";
            linkName = linkInfo.href.includes(".pdf") ? linkInfo.getAttribute("data-componentTitle") : (linkInfo.getAttribute("data-tracking") || linkInfo.textContent);
            linkUrl = linkInfo.href;
            displayTitle = linkInfo.getAttribute("data-tracking") || linkInfo.textContent;
            componentName = linkInfo.getAttribute("data-modal") ? "modal" : "cta";
            componentTitle = window.location.pathname == '/site-map' && linkInfo.closest("section") ? "sitemap":(linkInfo.getAttribute("data-componentTitle") || linkName);

            if (link.target.classList.contains("btn-change-selection") || link.target.classList.contains("btn-selection")) {
                componentTitle = linkInfo.getAttribute("data-componentTitle") || "Are you most interested in information and resources related to";
            }

            if (linkInfo.closest("header")) {
                componentName = "primary navigation";
                componentType = "navigation";
                componentPosition = "Header";
            } else if (linkUrl.includes('about-us') || linkUrl.includes('find-msl') ) {
                componentType = "navigation";
                componentPosition = "Header";
            } else if (linkInfo.closest("footer")) {
                componentType = "content";
                componentPosition = "Footer";
                componentName = "Footer"
                componentTitle="Footer"
            } else {
                componentType = "content";
                componentPosition = "Content";
            }

            if (displayTitle == "PLAY THE EPI GAME" ) {
                linkType = "internal";
            }
            
            interactionType = linkInfo.href.includes(".pdf") ? "File Download" : "Link";
            contentType = linkInfo.href.includes(".pdf") ? "PDF" : "link";
            mvaTier = linkInfo.href.includes(".pdf") ? "primary" : "";
            mvaType = linkInfo.href.includes(".pdf") ? "download" : "";
            mvaCategory = linkInfo.href.includes(".pdf") ? "Medical Guide" : "";
            mvaName = linkInfo.href.includes(".pdf") ? linkName : "";
        }

        function getCustomElementTracking(link) {
            if (link.target.id === "transcript" || link.target.parentElement.id === "transcript") {
                interactionType = "Tool";
                contentType = "Accordion";
                componentName = "accordion";
                linkName = document.querySelectorAll('[data-tracking="video-title"]')[0].innerHTML;
                displayTitle = "Transcript: " + (link.target.parentElement.classList.contains("expanded") ? "Open" : "Closed");
                toolName = "Video Transcript - " + (link.target.parentElement.classList.contains("expanded") ? "Open" : "Closed");
            }
           

            componentPosition = "Content";
            componentType = "content";
            linkType = "Internal";
            linkUrl = window.location.href;
        }
        function getButtonTracking(link) {
            linkInfo = link.target;
       
            interactionType = "link";
            contentType = "Accordion";
            componentName = "cta";
            componentTitle = linkInfo.getAttribute("data-componentTitle")
            linkName = linkInfo.getAttribute("data-tracking");
            displayTitle = linkInfo.getAttribute("data-tracking")
            componentPosition = "Content";
            componentType = "content";
            linkType = "Internal";
            linkUrl = window.location.href;

        }
        function getSearchTracking(link) {
            linkName = link.target.textContent;
            componentPosition = "Content";
            componentType = "content";
            linkType = "Internal";
            linkUrl = link.target.href ||  window.location.href;
          
            interactionType = "link";
            contentType = "link";
            componentName = "cta";
            componentTitle = "Search Results";

            if (link.target.classList.contains('CoveoTab') || link.target.parentElement.classList.contains('CoveoTab')) {
                componentTitle = "Search Results";
                componentName = "tabs";
            }
            if (link.target.classList.contains('coveo-results-per-page-list-item') || link.target.parentElement.classList.contains('coveo-results-per-page-list-item')) {
                componentTitle = "Search Results";
                componentName = "tool";
                interactionType = "Tool interaction";
                linkName = "pagination: "+link.target.parentElement.querySelectorAll('.coveo-results-per-page-list-item-text')[0].innerHTML;
                displayTitle = link.target.parentElement.querySelectorAll('.coveo-results-per-page-list-item-text')[0].innerHTML;
            }
            if (link.target.classList.contains('coveo-result-layout-selector') || link.target.parentElement.classList.contains('coveo-result-layout-selector')) {
                componentTitle = "Search Results";
                componentName = "tool";
                interactionType = "Tool interaction";
                linkName = link.target.parentElement.querySelectorAll('.coveo-result-layout-selector-caption')[0].innerHTML;
                displayTitle = link.target.parentElement.querySelectorAll('.coveo-result-layout-selector-caption')[0].innerHTML;
            }

            if (link.target.classList.contains('coveo-pager-list-item') || link.target.parentElement.classList.contains('coveo-pager-list-item')) {
                componentTitle = "Search Results";
                componentName = "tool";
                interactionType = "Tool interaction";
                linkName ="pagination: "+ link.target.parentElement.querySelectorAll('.coveo-pager-list-item-text')[0].innerHTML;
                displayTitle = link.target.parentElement.querySelectorAll('.coveo-pager-list-item-text')[0].innerHTML;
            }
            if (link.target.classList.contains('coveo-pager-next-icon') || link.target.parentElement.classList.contains('coveo-pager-next-icon') || link.target.parentElement.parentElement.classList.contains('coveo-pager-next-icon')) {
                componentTitle = "Search Results";
                componentName = "tool";
                interactionType = "Tool interaction";
                linkName = "pagination: right";
                displayTitle = ">";
            }
            if (link.target.classList.contains('coveo-pager-previous-icon') || link.target.parentElement.classList.contains('coveo-pager-previous-icon') || link.target.parentElement.parentElement.classList.contains('coveo-pager-next-icon')) {
                componentTitle = "Search Results";
                componentName = "tool";
                interactionType = "Tool interaction";
                linkName = "pagination: left";
                displayTitle = "<";
            }

            toolName = linkName;
            toolType = "Search";


            
        }

        function getFormTracking(link) {
            linkInfo = link.target;
            linkType = link.target.hasAttribute("data-modal")?"External": "Internal";
            linkName = link.target.getAttribute("data-tracking") || link.target.name;
            linkUrl = window.location.href;
            componentName = "cta";
            componentTitle = document.getElementById('page-title')?.innerText || linkInfo.getAttribute("data-componentTitle") ||'component';
            interactionType = "Link";
            contentType = "link";

            if (linkName == "Back") {
                linkType = "internal";
            }


            if (linkInfo.closest("header")) {
                componentType = "navigation";
                componentPosition = "Header";
            } else if (linkInfo.closest("footer")) {
                componentType = "navigation";
                componentPosition = "Footer";
            } else {
                componentType = "content";
                componentPosition = "Content";
            }

            if (linkInfo.type === "INPUT") {
                interactionType = 'Form';
                toolName = linkInfo.getAttribute("data-tracking") || linkInfo.name;
                componentTitle = linkInfo.getAttribute("data-componentTitle") || toolName;
                componentName = toolName;
                formName = linkInfo.getAttribute("data-componentTitle") || linkInfo.getAttribute("data-tracking");
            }

            if (linkInfo.nodeName === "button") {
                contentType = "link";
                componentName = "cta";
                componentTitle = linkInfo.getAttribute("data-componentTitle");
            }

            if (linkInfo.type === "text" || linkInfo.getAttribute("type") === "submit") {
                var valueField = document.getElementById(linkInfo.getAttribute("data-input"));

                fieldName = linkInfo.getAttribute("data-tracking") || link.target.name;
                fieldValue = linkInfo.value ? linkInfo.value : valueField ? valueField.value : "";
                interactionType = "Form";
                contentType = "form";
                componentName = "form";
                componentType = "form";
                componentTitle = linkInfo.getAttribute("data-componentTitle")|| formName;
                linkType = "form-initiation";
                stepName = "init"
                formCategory = "Services";
                formSubCategory = "Doctor Search"
        
                formName = linkInfo.getAttribute("data-componentTitle") || linkInfo.getAttribute("data-tracking");
            }

            if (linkInfo.getAttribute("type") === "submit") {
                linkName = "Submit";
                linkType = "form-submission";
                stepName = "submit";
                mvaTier = "primary";
                mvaCategory = linkInfo.getAttribute("data-mvaCategory") || "";
                mvaType = "form";
                mvaName = linkInfo.getAttribute("data-componentTitle") || linkInfo.getAttribute("data-tracking");
                fieldName = "";
                fieldValue = "";
                stepName="submit"
            }

            if (linkInfo.parentElement.type === "submit") {
                interactionType = "Tool";
                componentName = "tool";
                componentTitle = linkInfo.getAttribute("data-tracking") || "Search";
                toolName = componentTitle;
                toolFieldName = "Search box";
                toolFieldValue = "";
                toolType = "interactive search";
            }
        }

        if (time) {
            //get timed video tracking
            getVideoTracking(link, time);
        } else {
            if (link.target.closest("hosted-search-page")) {
                console.log("getSearchTracking");
                getSearchTracking(link);
            }else if (link.target.nodeName === 'A' || link.target.closest("a")) {
                //tracking for a element links
                console.log("getLinkTracking");
                getLinkTracking(link);

            } else if (link.target.closest("video-js")) {
                //only play one video at a time
                document.querySelectorAll('video').forEach(vid => {
                    if (vid.parentElement != link.target.closest("video-js")) {
                        vid.pause();
                    }
                });
                //tracking for video play
                getVideoTracking(link);
          
                this.videoTimeUpdate(link.target.closest("video-js"));

            }
            else if (link.target.getAttribute("tabindex") || link.target.parentElement.getAttribute("tabindex")) {
                //For javascript click functionality
                console.log("getCustomElementTracking");
                getCustomElementTracking(link);
            }
            else if ((link.target.nodeName === "INPUT" && link.type!=='click' )|| link.target.type === "submit" || link.target.parentElement.type === "submit") {
                console.log("getFormTracking", link.type );
                getFormTracking(link);
            } else {
                if ((link.target.nodeName === "INPUT" && link.type !== 'click') || link.target.type ==="button") {
                    console.log("getLinkTracking---else");
                    getButtonTracking(link);
                }
                
            }
        }


        const linkPageData = {
            link: {
                name: linkName,
                displayTitle: displayTitle ? displayTitle : linkName,
                type: linkType,
                url: linkUrl,
            },
            component:
            {
                type: componentType,
                l10title: '',
                title: componentTitle ? componentTitle : linkName,
                name: componentName,
                position: componentPosition,
            },
            content:
            {
                type: contentType,
                title: linkName,
                name: linkName,
            },
            interaction: {
                type: interactionType,
                name: ''
            },
            journey: {
                content: '', patient: '', messageBucket: ''
            },
            mva: {
                name: mvaName ? mvaName : '',
                tier: mvaTier ? mvaTier : '',
                type: mvaType ? mvaType : '',
                category: mvaCategory ? mvaCategory : ''
            }
        };

        const videoData = {
            video: {
                name: videoTitle,
                id: videoId ? videoId : '',
                length: videoLength ? videoLength : '',
                playback: videoDuration ? videoDuration : '',
                action: videoAction
            }
        }

        const toolData = {
            tool: {
                name: toolName,
                fieldName: toolFieldName ? toolFieldName : '',
                fieldValue: toolFieldValue ? toolFieldValue:'',
                interactionLocation: componentType,
                type: toolType,
            }
        }

        const formData = {
            form: {
                name: formName,
                category: formCategory,
                subCategory: formSubCategory,
                stepName: stepName,
                fieldName: fieldName,
                fieldValue: fieldValue
            }
        }

        let fullInteractionData;

        if (videoId || toolName || formName) {
            let additionalData = videoId ? videoData : toolName ? toolData : formData;
            fullInteractionData = { ...linkPageData, ...additionalData };
        }

        this.addInteractionDataToPageData(fullInteractionData ? fullInteractionData : linkPageData, fullInteractionData ? 'none' : 'link');
    }

    
    videoTimeUpdate(videoParent) {
        const video = videoParent.querySelector("video");
        const videoLength = videoParent.querySelector(".vjs-duration-display").innerHTML;
        const splitTime = videoLength.split(':');
        //Convert video time to seconds and get specific play through times
        var videoSeconds = Math.floor((+splitTime[0]) * 60 + (+splitTime[1]));
        const quarterTime = Math.floor(videoSeconds / 4);
        const halfTime = Math.floor(videoSeconds / 2);
        const fourthTime = Math.floor(videoSeconds / 4 * 3);

        const timeframes = [
            { time: quarterTime, triggered: false, duration: 25 },
            { time: halfTime, triggered: false, duration: 50 },
            { time: fourthTime, triggered: false, duration: 75 },
            { time: videoSeconds, triggered: false, duration: 100 }

        ]

        video.addEventListener("timeupdate", () => {

            let time = timeframes.find(i => i.time == Math.floor(video.currentTime) && i.triggered == false);
            if (time) {
                if (video.parentElement.classList.contains('vjs-has-started') && video.parentElement.classList.contains('vjs-playing') && !video.parentElement.classList.contains('vjs-ended')) {
                    time.triggered = true;
                    console.log("Time update", time, Math.floor(video.currentTime), video.currentTime, time.triggered);
                    this.trackInteraction(video, time.duration);

                }
            }
        })

    }

    addInteractionDataToPageData(interactionData, interactionType) {
        const allLinkData = {
            page: Object.assign(this.pageData.page, interactionData)
        };

        this.digitalData = { ...allLinkData, ...this.digitalData }


        const linkDomain = this.digitalData.page.link.url ? this.digitalData.page.link.url : '';
        const linkType = this.digitalData.page.link.type ? this.digitalData.page.link.type : '';
        const currentDomain = window.location.hostname;
        const errorMsg = document.querySelector(".error-input-container.show");


        if (interactionType !== "none" && linkDomain.includes(currentDomain) && linkType !== "Download") {
            sessionStorage.setItem(interactionType, JSON.stringify(this.digitalData, null, 2))
        } else {

        }

        if (linkType == 'form-initiation') {
            sessionStorage.setItem(linkType, JSON.stringify(this.digitalData))
   
        } else if (linkType == "form-submission") {
            //don't submit form until there is no error message
            if (!errorMsg) {
                sessionStorage.setItem(linkType, JSON.stringify(this.digitalData))
                this.digitalData = JSON.parse(sessionStorage.getItem('form-initiation'));
                console.log("link tracking ", this.digitalData, linkType, errorMsg)
                _satellite.track('trackAction');
                setTimeout(function () {
                    this.digitalData = JSON.parse(sessionStorage.getItem('form-submission'));
                    console.log("link tracking ", this.digitalData)
                    _satellite.track('trackAction');
                }, 100);
            }


        } else {
            console.log("link tracking", this.digitalData)
            _satellite.track('trackAction');
        }
        
    }
}



